import { useState } from "react"
import { useSelector } from "react-redux"
import SpaceCard from "~/components/SpaceCard/SpaceCard"
import CalendarSpacesCard from "~/components/CalendarSpacesCard/CalendarSpacesCard"
import SpaceCreateCard from "~/components/SpaceCreateCard/SpaceCreateCard"
import SpaceLoadingCard from "~/components/SpaceLoadingCard/SpaceLoadingCard"
import Heading from "~/components/Heading/Heading"
import Sidebar from "~/components/Sidebar/Sidebar"
import Button from "~/components/Button/Button"
import { useNavigate } from "react-router-dom"
import { sortSpaces, filteredSpaces } from "~/utils/SpaceUtils"
import { getUser, getSpaces } from "~/store"
import SearchField from "../../components/SearchField/SearchField"
import PageContent from "~/components/PageContent/PageContent"
import PageWithSidebar from "~/components/PageWithSidebar/PageWithSidebar"

import "./Spaces.scss"
import SpaceNotFoundCard from "~/components/SpaceNotFoundCard/SpaceNotFoundCard"

function Spaces() {
  const user = useSelector(getUser)
  const spaces = useSelector(getSpaces)
  const [search, setSearch] = useState("")
  const navigate = useNavigate()
  const loaded = Array.isArray(spaces)

  const placeholderCards = [1, 2, 3, 4, 5, 6].map((key) => {
    return <SpaceLoadingCard key={key} />
  })

  const spaceCards = sortSpaces(filteredSpaces(spaces, search), user).map(
    (space) => {
      return <SpaceCard key={space.name} attributes={space} />
    },
  )

  return (
    <PageWithSidebar>
      <PageContent style="light">
        <div className="Spaces">
          <div className="Spaces__header">
            <Heading text={"Hi " + user?.name} />
            {user?.organisation_name ? (
              <SearchField
                style="light"
                onChange={(value) => {
                  setSearch(value)
                }}
              />
            ) : (
              <Button
                type="button"
                text="Start collaborating"
                className="light mr-10"
                onClick={() => navigate("/organisations/new")}
              />
            )}
          </div>
          <div className="Spaces__scrollable">
            {!loaded ? placeholderCards : null}
            {loaded && user?.has_calendar_access && <CalendarSpacesCard />}
            {loaded ? <SpaceCreateCard /> : ""}
            {loaded && spaces.length > 0 && spaceCards.length == 0 ? (
              <SpaceNotFoundCard />
            ) : (
              spaceCards
            )}
          </div>
        </div>
      </PageContent>
      <Sidebar style="secondary" />
    </PageWithSidebar>
  )
}

export default Spaces
